import { OrderOrigin } from '../../interfaces/OrderOrigin'
import { OrderOriginAction } from '../actions/orderOriginActions'
import { GET_ORDERORIGINS_EXITO } from '../types/orderOriginActionsTypes'

export interface OrderOriginState {
  orderOriginsState: {
    orderOrigins?: OrderOrigin[]
    error?: string | undefined
  }
}

const initialState: OrderOriginState = {
  orderOriginsState: { orderOrigins: [], error: '' }
}

export const orderOriginReducer = (
  state: OrderOriginState = initialState,
  action: OrderOriginAction
): OrderOriginState => {
  if (action.type === GET_ORDERORIGINS_EXITO) {
    return {
      ...state,
      orderOriginsState: {
        orderOrigins: action.orderOrigins,
        error: action.error
      }
    }
  }
  return state
}
